import { ProductMenu } from '../product-menu';
import { Type } from '@angular/core';
import { MenuHeaderTitleImageComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-title/menu-header-title-image/menu-header-title-image.component';
import { Section } from '../section/section';
import { SectionRowViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-row-view-models/SectionRowViewModel';
import { StrainType } from '../../enum/dto/strain-classification.enum';
import { ColumnGrouping } from '../section/column-grouping';
import { ColumnUtils } from '../../../utils/column-utils';
import { BandedRowMode } from '../../enum/shared/banded-row-mode.enum';
import { BandedRowColorContrast } from '../../enum/shared/banded-row-color-contrast.enum';
import { SortVariantUtils } from '../../../utils/sort-variant-utils';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { SectionColumnType } from '../../enum/shared/section-column-type';
import { SectionColumnProductInfoType } from '../../enum/shared/section-column-product-info-type';
import { SectionColumnViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/SectionColumnViewModel';
import { WithinNameCell } from '../../enum/shared/within-name-cell';

export class PurLifeMenu extends ProductMenu {
  getThemeClass(): string {
    return this.isLandscape() ? 'pur-life-theme-landscape' : 'pur-life-theme';
  }

  getHeaderType(): Type<MenuHeaderTitleImageComponent> {
    return MenuHeaderTitleImageComponent;
  }

  centerMenuTitleWhenLogoIsHidden(): boolean {
    return true;
  }

  getShowInlineLabels(): WithinNameCell {
    return WithinNameCell.TitleLine;
  }

  getShowProductSubtitle(): boolean {
    return false;
  }

  override fixedLocationBrandPropertyIsWithin(): WithinNameCell | null {
    return WithinNameCell.TitleLine;
  }

  override getColumnOrdering(): Map<SectionColumnType, number> {
    return new Map<SectionColumnType, number>([
      [SectionColumnProductInfoType.StrainType, 1],
      [SectionColumnProductInfoType.ProductTitle, 2],
      [SectionColumnProductInfoType.Brand, 3],
      [SectionColumnProductInfoType.Badge, 4],
      [SectionColumnProductInfoType.Strain, 5],
      ...SectionColumnViewModel.getDefaultAdditionalDetailsColumnOrder(6),
      SectionColumnViewModel.getDefaultProductTagGroupColumnOrdering(7),
      ...SectionColumnViewModel.getDefaultCannabinoidColumnOrdering(8),
      ...SectionColumnViewModel.getDefaultTerpeneColumnOrdering(9),
      [SectionColumnProductInfoType.QuantityAndSize, 10],
      [SectionColumnProductInfoType.Quantity, 11],
      [SectionColumnProductInfoType.Size, 12],
      [SectionColumnProductInfoType.VariantType, 13],
      [SectionColumnProductInfoType.Stock, 14],
      [SectionColumnProductInfoType.GradingResults, 15],
      [SectionColumnProductInfoType.VariantPrice, 16],
      [SectionColumnProductInfoType.VariantSecondaryPrice, 17]
    ]);
  }

  getShouldInflateColumnHeaderForRow(s: Section, col: SectionColumnViewModel, rows: SectionRowViewModel[]): boolean {
    const classification = col?.columnType === SectionColumnProductInfoType.StrainType;
    return !classification;
  }

  getProductWrapperClass(odd: boolean): string {
    if (odd) {
      return 'product-odd';
    } else {
      return 'product-even';
    }
  }

  getUniqueClassificationList(): StrainType[] {
    return super.getUniqueClassificationList()?.sort(SortVariantUtils.genericStrainTypeSort);
  }

  getPriceColumnTitle(col: SectionColumnViewModel): string {
    return super.getPriceColumnTitle(col)?.trim();
  }

  getLineModeColumnGroupings(sectionColumnViewModels: SectionColumnViewModel[]): ColumnGrouping[] {
    return ColumnUtils.oneBigGrouping();
  }

  getGridModeColumnGroupings(sectionColumnViewModels: SectionColumnViewModel[]): ColumnGrouping[] {
    return ColumnUtils.oneBigGrouping();
  }

  getSectionHeaderUnderlined(): boolean {
    return false;
  }

  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.Roboto.SemiBold_600, FONT.Roboto.Bold_700, FONT.Roboto.Black_900, FONT.Roboto.BlackExtra_1000];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/yki2mdw.css';
  }

  getShowFooter(): boolean {
    return false;
  }

  getSectionWrapperClass(...args: any[]): string {
    if (this.isPortrait() && this.columnCount > 1) {
      return 'portrait-multi-column';
    } else {
      return null;
    }
  }

  getHeaderLogoMargin(): string {
    if (this.isLandscape() || (this.isPortrait() && this.columnCount > 1)) {
      return `0 1rem 0 0`;
    } else {
      return null;
    }
  }

  bandedRowMode(): BandedRowMode {
    return BandedRowMode.Even;
  }

  bandedRowColor(rowViewModel: SectionRowViewModel, odd: boolean): string {
    return super.bandedRowColor(rowViewModel, odd, 0.25);
  }

  bandedRowsDefaultEnabled(): boolean {
    return true;
  }

  bandedRowColorContrast(): BandedRowColorContrast {
    return BandedRowColorContrast.Darken;
  }
}
